var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccordionArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00039 6.65008C5.88372 6.65008 5.77139 6.63342 5.66339 6.60008C5.55472 6.56675 5.45872 6.50008 5.37539 6.40008L0.85039 1.90008C0.717057 1.75008 0.650391 1.57508 0.650391 1.37508C0.650391 1.17508 0.725391 1.00008 0.875391 0.850083C1.02539 0.716749 1.20039 0.650082 1.40039 0.650082C1.60039 0.650082 1.77539 0.716749 1.92539 0.850083L6.00039 4.92508L10.1004 0.850083C10.2337 0.700082 10.4004 0.629082 10.6004 0.637082C10.8004 0.645749 10.9754 0.716749 11.1254 0.850083C11.2754 1.00008 11.3504 1.17908 11.3504 1.38708C11.3504 1.59575 11.2754 1.76675 11.1254 1.90008L6.62539 6.40008C6.54206 6.50008 6.44639 6.56675 6.33839 6.60008C6.22972 6.63342 6.11706 6.65008 6.00039 6.65008Z",
    fill: "#707683"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionArrow);
export default __webpack_public_path__ + "static/media/accordion-arrow.c501f8c0.svg";
export { ForwardRef as ReactComponent };